import Vue from 'vue';
import Vuex from 'vuex';
import doctors from './modules/doctors';
import data from './modules/data';
import cmsApiCatalogs from './modules/cms-api-catalogs';
import clinics from './modules/clinics';
import reviews from './modules/reviews';
import ai from './modules/ai';
import chatApi from './modules/chat-api';
import offersClusters from './modules/offers-clusters';
import helpCenter from './modules/help-center';
import helpCenterCategories from './modules/help-center-categories';
import offers from './modules/offers';
import articles from './modules/articles';
import customPages from './modules/customPages';
import specialities from './modules/specialities';
import clinicContentModeration from './modules/clinic-content-moderation';
import offerServices from './modules/offer-services';
import offerQuestions from './modules/offer-questions';
import admin from './modules/admin';
import agencies from './modules/agencies';
import employees from './modules/employees';
import clinicAgency from './modules/clinicAgency';
import operationResultImages from './modules/operation-result-images';
import prices from './modules/prices';
import docs from './modules/docs';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    doctors,
    data,
    cmsApiCatalogs,
    clinics,
    reviews,
    ai,
    chatApi,
    offersClusters,
    helpCenter,
    helpCenterCategories,
    offers,
    articles,
    customPages,
    specialities,
    clinicContentModeration,
    offerServices,
    offerQuestions,
    admin,
    agencies,
    employees,
    clinicAgency,
    operationResultImages,
    prices,
    docs,
  },
  state: {
    isLoaderVisible: false,
  },
  mutations: {
    SET_DATA(state, { type, data }) {
      state[type] = data;
    },
  },
  actions: {
    setLoader({ commit }, data) {
      commit('SET_DATA', { type: 'isLoaderVisible', data });
    },
  },
});
